<template>
  <div id="app">
    <span>
      <img alt="Vue logo" src="./assets/logo.png">
      <img alt="Twilio logo" src="./assets/twilio-logo.png">
      <img alt="MS logo" src="./assets/mediascience.png">
    </span>

    <md-tabs md-alignment="centered" style="background: #fafafa !important">
      <md-tab md-label="Home">
        <Form/>
        <Health/> 
      </md-tab>

      <md-tab md-label="History">
        <br>
        Work in Progress
        <History/>
      </md-tab>

      <md-tab md-label="Messages">
        <br>
        Work in Progress
      </md-tab>
    </md-tabs>

    <!-- <Form/>
    <Health/> -->
  </div>
</template>

<script>
import Form from './components/Form.vue'
import Health from './components/Health.vue'

import History from './components/History.vue'

export default {
  name: 'app',
  components: {
    Form, Health, History
  }
}
</script>

<style>
#app {
  /* font-family: 'Avenir', Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  margin-top: 60px;
  margin-bottom: 60px;
}
.md-tabs-navigation {
  background: #fafafa !important;
}
.md-tab {
  /* background: #fafafa; */
}
.md-dialog {
  /* background: #fafafa !important; */
}
</style>

<style scoped>
.md-tab {
  padding: 0px !important;
}
</style>

